// extracted by mini-css-extract-plugin
module.exports = {"datetime":"RequestCanceled_datetime_1_w2P"};